// extracted by mini-css-extract-plugin
export default {"mediumWidth":"sLSSyCVKXLHsiQTbbj1g","popupMobilePanel":"MmJrUBxLcoDxaldLV1rh"};